/*
 * Lemonade Training Oy copy rights all right reserved.
 */

import type { BoxMemberPermissions } from "./box";
import type { Timestamp } from "firebase/firestore";

/* -------------- [ Enums and Unions ] ------------------ */
export type InviteStatus = "Pending" | "Accepted" | "Declined" | "Expired";

export type InvitationType =
  | "toProgramming"
  | "toCoachingSub"
  | "toBox"
  /**
   * LT-511 — explicit invite from an independent coach to an athlete that
   * establishes a CoachAthletes relationship on accept. Accept handler
   * (acceptOrDeclineInvitation) writes the relationship doc with
   * `createdBy: "invitation"` and `sourceID` = the invitation document ID.
   */
  | "toCoachAthlete";

/** Roles a staff invite may confer. "admin" invites are owner-sent and re-verified against Box.ownerUID at accept. */
export const INVITE_BOX_ROLES = ["admin", "coach"] as const;
export type InviteBoxRole = (typeof INVITE_BOX_ROLES)[number];

export type InviteProductDetails = {
  type: string;
  id: string;
  ownerID: string;
};

/* -------------- [ Invite ] ------------------ */
export type Invite = {
  id?: string;
  invitationType: InvitationType;
  // -----------------------------------
  title: string;
  message?: string;
  senderID: string;
  senderName: string;
  recipientID?: string;
  recipientName?: string;
  recipientEmail: string;
  // -----------------------------------
  status: InviteStatus;
  // -----------------------------------
  product?: InviteProductDetails; // Optional for box invitations
  // -----------------------------------
  // Box invitation fields
  boxID?: string;
  /** "athlete" is retained for compatibility and never written. */
  boxRole?: InviteBoxRole | "athlete";
  boxPermissions?: BoxMemberPermissions; // Permissions for box coach invitations
  // -----------------------------------
  // Timestamps
  createdAt?: Timestamp | Date;
  updatedAt?: Timestamp | Date;
};
